import ConceptChip from '../core/ConceptChip';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CancelButton from '../../core/CancelButton';
import PrimaryButton from '../../core/PrimaryButton';
import { globalStyles as styles } from '../../core/style/gstheme';

class RelationshipAreYouSure extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: true
    };
  }

  notSure = () => {
    this.setState({ open: false });
    this.props.onNotSure();
  }

  sure = () => {
    this.setState({ open: false });
    this.props.onSure();
  }

  render() {

    const { classes, conceptList, graph, defaultLang, source, isTopConcept } = this.props;

    return (
      <Dialog
        data-test="are-you-sure"
        open={this.state.open}
        onClose={this.notSure}
        aria-labelledby="areyousure-dialog-title" >
        <DialogTitle disableTypography className={classes.mainHeading} id="areyousure-dialog-title">Are You Sure?</DialogTitle>
        <DialogContent>
          <DialogContentText>You are in monohierarchy mode. This action impacts the following concept.</DialogContentText>
          <div data-test="impacted-resource">
            <ConceptChip
              id={source}
              graph={graph}
              loadOptions={{
                language: defaultLang
              }}
              defaultLang={defaultLang} />
          </div>
          {isTopConcept && <DialogContentText data-test="is-top-text">The above concept is a top concept of this scheme. Confirming this action will remove this relationship.</DialogContentText>}
          {conceptList && conceptList.length > 0 && <DialogContentText>Confirming this action will remove existing broader relationships for this concept. In this scheme the following are broader concepts.</DialogContentText>}
          <div data-test="broader-resource">
            {conceptList && conceptList.map(id =>
              <ConceptChip
                key={id}
                id={id}
                graph={graph}
                loadOptions={{
                  language: defaultLang
                }}
                defaultLang={defaultLang} />
            )}
          </div>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <CancelButton onClick={this.sure}>Yes</CancelButton>
          <PrimaryButton onClick={this.notSure}>No</PrimaryButton>
        </DialogActions>
      </Dialog>
    );
  }
}

RelationshipAreYouSure.propTypes = {
  isTopConcept: PropTypes.bool.isRequired,
  source: PropTypes.string.isRequired,
  graph: PropTypes.string.isRequired,
  defaultLang: PropTypes.string.isRequired,
  message: PropTypes.array,
  conceptList: PropTypes.array,
  onSure: PropTypes.func.isRequired,
  onNotSure: PropTypes.func.isRequired,
  classes: PropTypes.object
};

export default withStyles(styles)(RelationshipAreYouSure);